import { useState } from "react";
import { inr, mediaUrl } from "@/lib/api";
import { SectionHead } from "@/components/site/SectionHead";
import CheckoutDialog from "@/components/site/CheckoutDialog";
import { Skeleton } from "@/components/ui/skeleton";
import { useLang } from "@/context/LangContext";

export default function Courses({ courses }) {
  const [selected, setSelected] = useState(null);
  const { t, item } = useLang();

  return (
    <section id="courses" className="max-w-6xl mx-auto px-5 py-20 sm:py-28">
      <SectionHead eyebrow={t("courses.eyebrow")} title={t("courses.title")} text={t("courses.text")} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-parchment-300 border border-parchment-300 rounded-2xl overflow-hidden">
        {!courses && Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-56 rounded-none" />)}
        {courses?.map((c, i) => {
          const [title, desc, tag] = item(c.id, c.title, c.desc, c.tag);
          return (
          <article key={c.id} className="group bg-parchment hover:bg-white transition-colors p-7 flex flex-col" data-testid={`course-card-${c.id}`}>
            {c.image && (
              <div className="-mx-7 -mt-7 mb-6 aspect-[16/9] overflow-hidden">
                <img src={mediaUrl(c.image)} alt={title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-testid={`course-image-${c.id}`} />
              </div>
            )}
            <div className="flex items-center justify-between">
              <span className="eyebrow">{tag}</span>
              <span className="font-serif text-forest-800/30 text-2xl">{String(i + 1).padStart(2, "0")}</span>
            </div>
            <h3 className="mt-4 text-2xl font-semibold text-forest-800 leading-snug">{title}</h3>
            <p className="mt-3 text-sm text-[#57645A] leading-relaxed flex-1">{desc}</p>
            <div className="mt-6 flex items-center justify-between">
              <span className="font-serif text-3xl font-bold text-forest-800" data-testid={`course-fee-${c.id}`}>{inr(c.fee)}</span>
              <button onClick={() => setSelected(c)} className="px-5 py-2.5 rounded-full bg-forest-800 text-parchment text-sm font-medium hover:bg-forest-700 transition-colors" data-testid={`course-enrol-${c.id}`}>
                {t("courses.enrol")}
              </button>
            </div>
          </article>
          );
        })}
      </div>
      <CheckoutDialog
        open={!!selected}
        onOpenChange={(o) => !o && setSelected(null)}
        kind="course"
        course={selected}
        title={selected ? item(selected.id, selected.title, selected.desc)[0] : ""}
        total={selected?.fee || 0}
      />
    </section>
  );
}
